import React, { useState, useRef, useEffect } from 'react';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import {
  FiTrash2,
  FiInfo,
  FiPlusCircle,
  FiMinusCircle,
  FiMessageSquare,
} from 'react-icons/fi';

import { Form } from '@unform/web';
import { toast } from 'react-hot-toast';
import TextArea from '~/components/Form/Textarea';
import { useCart } from '~/context/OrderingSystem/Cart';
import { ModalConfirmation } from '~/components/ModalConfirmation';
import { DefaultInput } from 'ui-kit-takeat';
import {
  Container,
  MenuItemBody,
  MenuItemDescription,
  MenuItemComplements,
  MenuItemQuantity,
  ConfirmButton,
  CancelButton,
  InputProductAmount,
} from './styles';

const MenuItemList = ({ item }) => {
  const {
    removeFromCart,
    increment,
    decrement,
    addObservation,
    changeProductAmount,
  } = useCart();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalObservation, setIsModalObservation] = useState(false);

  const formRef = useRef(null);

  function toggleModal() {
    setIsOpen(!modalIsOpen);
  }

  function toggleModalOservation() {
    setIsModalObservation(!modalObservation);
  }

  function handleRemoveFromCart(id, item_id) {
    removeFromCart(id, item_id);

    toggleModal();
  }

  async function handleSubmit(data) {
    try {
      await addObservation(
        item?.id,
        item?.ordering_system_id,
        data.observation
      );
      setIsModalObservation(false);
    } catch (error) {
      toast.error(`Erro ao inserir observação!`);
      console.log(error);
    }
  }

  function replaceValue(value) {
    if (typeof value === 'string') {
      const newValue = value?.replace('.', ',');

      return newValue;
    }
    return value.toString().replace('.', ',');
  }

  const [amount, setAmount] = useState(item?.amount);

  // Sincronizar o estado local sempre que item.amount mudar
  useEffect(() => {
    setAmount(item.amount);
  }, [item.amount]);

  function handleChangeProductAmount(id, ordering_system_id, value) {
    setAmount(Number(value));
    changeProductAmount(id, ordering_system_id, Number(value));
  }

  return (
    <Container>
      <MenuItemBody key={item.basket_id}>
        <ModalConfirmation
          isOpen={modalIsOpen}
          toggle={toggleModal}
          cancel={toggleModal}
          confirm={() => handleRemoveFromCart(item.basket_id, item.id)}
          title="Deseja realmente excluir esse produto?"
        />

        <Modal isOpen={modalObservation} toggle={toggleModalOservation}>
          <ModalBody>
            <p>Adicione a observação para o produto</p>

            <Form onSubmit={handleSubmit} ref={formRef}>
              <TextArea
                name="observation"
                type="text"
                placeholder="Digite a observação"
                id="observations_input"
              />
              <ModalFooter>
                <ConfirmButton type="submit">Enviar</ConfirmButton>
                <CancelButton onClick={toggleModalOservation}>
                  Cancelar
                </CancelButton>
              </ModalFooter>
            </Form>
          </ModalBody>
        </Modal>

        <MenuItemDescription>
          <strong>{item.name}</strong>

          {item?.observation && (
            <div>
              <FiInfo color="#fb4a20" />

              <span>{item?.observation}</span>
            </div>
          )}
          <MenuItemComplements>
            {item?.complement_categories?.map((category) =>
              category.complements
                .filter((comp) => comp.amount > 0)
                .map((items) => <p key={items.name}>{items.name}</p>)
            )}
          </MenuItemComplements>
        </MenuItemDescription>
        <MenuItemQuantity>
          {item?.use_weight ? (
            <strong> {`${replaceValue(item?.weight || 0)} kg`} </strong>
          ) : (
            <>
              {!item?.is_unitary && (
                <FiMinusCircle
                  color="#FF281E"
                  size={20}
                  onClick={() => {
                    decrement(item.id, item.ordering_system_id);
                  }}
                />
              )}

              {!item?.is_unitary ? (
                <InputProductAmount
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  value={amount}
                  onChange={(e) =>
                    handleChangeProductAmount(
                      item.id,
                      item.ordering_system_id,
                      e.target.value
                    )
                  }
                />
              ) : (
                <span style={{ color: '#FF281E', fontSize: 20 }}>{amount}</span>
              )}

              {!item?.is_unitary && (
                <FiPlusCircle
                  color="#FF281E"
                  size={20}
                  onClick={() => {
                    increment(item.id, item.ordering_system_id);
                  }}
                />
              )}
            </>
          )}

          <FiTrash2
            color="#FF281E"
            size={20}
            onClick={toggleModal}
            title="Deletar produto"
          />
          <FiMessageSquare
            color="#FF281E"
            size={20}
            title="Adicionar observação"
            style={{ marginLeft: 20 }}
            onClick={() => {
              setIsModalObservation(true);
              setTimeout(() => {
                return document.getElementById('observations_input')?.focus();
              }, 1);
            }}
          />
        </MenuItemQuantity>
      </MenuItemBody>
    </Container>
  );
};

export default MenuItemList;
